import { render, staticRenderFns } from "./loginCambiarPassword.vue?vue&type=template&id=c7850f6c&scoped=true"
import script from "./loginCambiarPassword.vue?vue&type=script&lang=js"
export * from "./loginCambiarPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7850f6c",
  null
  
)

export default component.exports